import React from "react";


function NoticeRoot({ globalData }){
  let notices = globalData?.general?.notice || [];
    return(
        <div className="notice-root">
              <div className="notice-bg">
                <div className="notice-icon">
                  <svg className="am-icon am-icon-notice-icon_30ad41de am-icon-md"><use xlinkHref="#notice-icon_30ad41de" /></svg>
                </div>
                <div className="marquee">
                  <div className="marquee" >
                    <div className="marquee_content">
                      { notices.map((item, index) => (
                      <span className="content-item">{item}</span>
                      ))}
                     
                    </div>
                  </div>
                </div>
              </div>
            </div>
    );
}
export default NoticeRoot;